<div [formGroup]="form" class="flex flex-column gap-2">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <p-inputNumber
    styleClass="w-full"
    ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
    placeholder="{{ item.placeholder || '' | translate }}"
    pInputText
    [maxlength]="item.config?.maxLength || maxLength"
    [min]="item.config?.minValue"
    [max]="item.config?.maxValue"
    [formControlName]="item.key"
    [mode]="item.config?.mode || 'decimal'"
    [(ngModel)]="item.value"
    [minFractionDigits]="minFractionDigits"
    [maxFractionDigits]="maxFractionDigits"
  >
  </p-inputNumber>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
  <small class="p-error block font-italic" *ngIf="isInValid && hasError('max')">
    {{
      item.errorMessage?.max?.message || ''
        | translate : item.errorMessage?.max?.params
    }}
  </small>
</div>
